import React from 'react'
import { ConfirmationModal } from 'transfix-ui'

interface IQRCodeVerificationModalProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
}

export const QRCodeVerificationModal = ({
  isOpen,
  onCancel,
  onConfirm,
}: IQRCodeVerificationModalProps) => {
  const closeModalHandler = () => {
    onCancel()
  }

  const submitHandler = () => {
    onConfirm()
  }

  return (
    <ConfirmationModal
      title='Assign new driver and send QR code?'
      size={4}
      open={isOpen}
      actions={[
        { label: 'Cancel', type: 'dismiss' },
        {
          label: 'Confirm changes',
          type: 'confirm',
          action: submitHandler,
        },
      ]}
      onClose={closeModalHandler}
      dataTest='qr-verification'>
      This load is currently active. The verification QR code sent to the existing driver will be
      deactivated. The new driver assigned will receive an SMS with a new QR code to verify
      themselves at pickup.
    </ConfirmationModal>
  )
}
